import { ReactNode } from "react";
import { Reveal } from "@/lib/motion";

interface Props {
  eyebrow: string;
  titulo: string;
  lead?: string;
  children?: ReactNode;
}

export function PageHero({ eyebrow, titulo, lead, children }: Props) {
  return (
    <section className="border-b border-hairline bg-parchment">
      <div className="mx-auto max-w-7xl px-4 pb-14 pt-16 sm:px-8 sm:pb-20 sm:pt-24">
        <Reveal y={16}>
          <p className="eyebrow mb-5">{eyebrow}</p>
          <h1 className="max-w-4xl font-serif text-4xl leading-[1.08] tracking-tight text-ink-deep sm:text-5xl lg:text-6xl">
            {titulo}
          </h1>
          {lead && <p className="mt-6 max-w-2xl text-lg leading-relaxed text-ink-muted">{lead}</p>}
          {children}
        </Reveal>
      </div>
    </section>
  );
}
